/*
 * @Description: 
 * @Autor: pangting
 * @Date: 2020-12-10 11:51:37
 * @LastEditors: pangting
 * @LastEditTime: 2022-01-25 09:03:05
 */
import {netsysconfigBaseApi} from "./netsysconfigBaseApi"
import {Methods} from '@newview/infrastructure'
import {BaseVue} from "@newview/base-web";

/**
 * 项目工程划分类别数据操作
 */
export class OAuthApi extends netsysconfigBaseApi {
    public get ControllerName(): any {
        return 'OAuth'
    }
    /**
     * 登录
     * @param UsrObj 登录信息
     */
    public GetToken (UsrObj: any) {
        let basevue = new BaseVue();
        let nowProjectSKey = basevue.$globalData.nowProjectSKey;
        UsrObj.SystemType = 1;   //1：PC端   2：移动端
        UsrObj.OpenId = null;    //微信登录
        UsrObj.nowProjectSKey = nowProjectSKey   //项目SKey
        return this.send(UsrObj, 'Token', Methods.GET)
    }
    /**
     * 登录新（验证码二次验证）
     * @param UsrObj 登录信息
     */
     public GetTokenWithTicket (UsrObj: Object) {
        return this.send(UsrObj, 'GetTokenWithTicket', Methods.POST)
    }
    public GetConstructionData (UsrObj: Object) {
        return this.send(UsrObj, 'GetConstructionData', Methods.GET)
    }
    
    /**
     * PC二维码登录
     * @param UsrObj 登录信息
     */
     public TokenAuthor (Token) {
        return this.send({Token:Token}, 'TokenAuthor', Methods.GET)
    }

    /**
     * @description: 校验验证码
     * @param {*} phone
     * @param {*} Code
     * @return {*}
     */    
    public VerificationCode(phone,Code){
        return this.send({Mobile:phone,Code:Code}, 'VerificationCode', Methods.GET)
    }

    /**
     * 检查是否存在账户
     * @param Account
     * @constructor
     */
    public GetIsExistUserByAccount(Account){
         return this.send({account:Account},"GetIsExistUserByAccount",Methods.GET)
    }

    public SendVerificationCode(Account){
        return this.send({Account:Account,Type:2},"SendVerificationCode",Methods.POST)
    }
    public ResetPasswordByUserId(Id,pwd){
        return this.send({UserId:Id,newPwd:pwd},"ResetPasswordByUserId",Methods.POST)
    }

    /**
     * @description 获取访问token
     * @param key 
     * @returns 
     */
    public GetVisitorToken(key){
        return this.send({},"GetVisitorToken?key="+key,Methods.GET)
    }

    /**
     * @description: 根据用户名和授权token获取登录信息
     * @param {*} account
     * @param {*} token
     * @return {*}
     * @author: pangting
     */     
    OAuthByToken(account,token){
        return this.send({},"OAuthByToken?account="+account+"&token="+token,Methods.POST)
    }
    ChangeUserSystemRole(BIId:number,RId:number,UId:number){
        return this.send({BIId,RId,UId},"ChangeUserSystemRole",Methods.GET)
    }

    public AppBrandInfor(APSKey){
        return this.send({APSKey:APSKey},"AppBrandInfor",Methods.GET)
    }
}
